module.exports = __webpack_public_path__ + "static/media/sticker-2.d5fd295e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/CovidSocial/sticker-2.PNG
// module id = 455
// module chunks = 0